import React from "react";
import { Container, Time, Plate } from "./ScheduleBadgeStyles";

interface Props {
  time: string;
  plate: string;
}

const ScheduleBadge: React.FC<Props> = ({ time, plate }) => {
  return (
    <Container>
      <Time>{time}</Time>
      <Plate>{plate}</Plate>
    </Container>
  );
};

export default ScheduleBadge;
